export default __webpack_public_path__ + "static/media/Western-Canada.06bfb77a.jpg";